<template>
    <div class="page-container">
        <nav-bar ref="navBar" :default-opacity=".5" :maxOpacity="0.5" bgColor="#000" fontColor="#000">
            <div class="navigation-content">
                <img alt="" class="back" src="../../assets/images/postalNewCustomer/back.png" @click="$router.go(-1)">
                <p class="title">我的奖励</p>
                <div class="back"></div>
            </div>
        </nav-bar>
        <div class="page-content">
            <div class="reward-list">
                <div v-for="item in rewardList" :key="item.id" class="reward-item">
                    <div class="reward-info">
                        <p class="reward-name">{{ item.prizeName }}</p>
                        <p class="reward-time">{{ moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') }}</p>
                    </div>
                    <div class="operation">
                        <template v-if="item.prizeType === 4">
                            <img v-if="!item.writeOffStatus" alt="" src="../../assets/images/postalNewCustomer/salesclerkCancel.png" @click="handleExchange(item)">
                            <img v-else alt="" src="../../assets/images/postalNewCustomer/awardBack2.png">
                            <p @click="goToInstruction(item)">
                                使用说明
                            </p>
                        </template>
                        <template v-else-if="item.prizeType === 0 || item.prizeType === 1">
                            <img alt="" src="../../assets/images/postalNewCustomer/awardBack1.png" @click="connectCustomerService(item.prizeSubId)">
                        </template>
                        <template v-else-if="item.prizeType === 5">
                            <img alt="" src="../../assets/images/postalNewCustomer/view-reward.png" @click="handleViewReward(item)">
                        </template>
                        <template v-else-if="item.prizeType === 3">
                            <img alt="" src="../../assets/images/postalNewCustomer/sence.png" @click="goToInstruction(item)">
                        </template>
                        <template v-else>
                            <img alt="" src="../../assets/images/postalNewCustomer/use-button.png" @click="goToInstruction(item)">
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <show-reward-modal v-if="visible" :prize-id="prizeId" :prize-type-code="prizeTypeCode" :type="prizeType" :visible.sync="visible" />
        <save-avatar-modal :avatar-no="avatarNo" :visible.sync="showSaveModal" />
        <!-- 核销弹窗 -->
        <popup :isWriteOff="isWriteOff" @handleWriteReward="handleWriteReward" couponType="writeOff" @closeWriteOff="isWriteOff = false"></popup>
        <!-- 核销成功弹窗 -->
        <popup :writeSuccess="writeSuccess" @closeWriteSuccess="writeSuccess = false"></popup>
    </div>
</template>

<script>
import { actions, namespace } from "@/store/modules/postalNewCustomer";
import SaveAvatarModal from "@/views/postalNewCustomer/SaveAvatarModal";
import ShowRewardModal from '@/views/postalNewCustomer/ShowRewardModal';
import popup from './components/Popups.vue'
import moment from 'moment'
import { Icon } from 'vant';
import { mapActions, mapState } from "vuex";
import navBar from './components/NavBar.vue'
import { writeOffReward } from '../../services/modules/postalNewCustomer'

const activeId = '114';
const MATERIAL = 'material'; // 实物奖励类型

export default {
    name: "MyReward",
    components: {
        Icon,
        ShowRewardModal,
        SaveAvatarModal,
        navBar,
        popup
    },
    data() {
        return {
            visible: false,
            prizeId: '',
            prizeType: '',
            prizeTypeCode: '',
            showSaveModal: false,
            avatarNo: '',
            isWriteOff: false,//是否显示核销弹窗
            writeSuccess: false,//是否显示核销成功弹窗
        }
    },
    computed: {
        ...mapState(namespace, {
            rewardList: state => state.myRewardList
        }),
        token() {
            const localToken = sessionStorage.getItem('token');
            return this.$store.state.user.token || localToken;
        },
        phone() {
            const localPhone = sessionStorage.getItem('phone');
            return this.$store.state.user.phone || localPhone;
        },
        deviceCoding() {
            const localDeviceCoding = sessionStorage.getItem('deviceCoding');
            return this.$store.state.user.deviceCoding || localDeviceCoding;
        },
    },
    created() {
        this.handleGetRewardList();
    },
    activated() {
        this.handleGetRewardList();
    },
    methods: {
        ...mapActions(namespace, {
            getMyRewardList: actions.GET_MY_REWARD
        }),
        moment,
        async handleGetRewardList() {
            const toast = this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            });
            const res = await this.getMyRewardList({
                activeBaseInfoId: activeId,
                token: this.token,
                phone: this.phone
            });
            toast.close();
            if (res.respcod !== '01') {
                this.$toast({
                    message: res.respmsg
                })
            }
        },
        handleExchange(prize) {
            this.prizeType = '';
            this.prizeId = prize.id;
            this.prizeTypeCode = prize.prizeSubId;
            // this.visible = true;
            this.isWriteOff = true
        },
        connectCustomerService(typeCode) {
            this.prizeType = MATERIAL;
            this.prizeTypeCode = typeCode;
            this.visible = true;
        },
        handleViewReward(prize) {
            this.avatarNo = prize.ext1;
            this.showSaveModal = true;
        },
        goToInstruction(prize) {
            //红包类型
            let arr = [
                '52bbc48b-61dc-4938-bf01-b80007310a63',
                'a8638ea8-2e05-4e00-a7ca-b4f7f2a397df',
                '524bdd29-b582-4bb5-9b55-95af5e1b9824',
                'c300db21-66ce-41b3-8332-35b8d9690a29'
            ]
            let prizeId = prize.prizeSubId
            if (arr.includes(prizeId)) prizeId = 'reward'
            this.$router.push({
                name: 'postalRules',
                query: { prizeId }
            })
        },
        //核销
        handleWriteReward(writeOffCode) {
            let jsonData = {
                code: writeOffCode,
                id: this.prizeId
            }
            writeOffReward(jsonData).then(res => {
                console.log(res)
                if (res.data) {
                    this.isWriteOff = false
                    this.writeSuccess = true
                    this.handleGetRewardList();
                } else {
                    this.$toast('核销失败，请检查核销密码');
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./components/function.scss";

img {
    display: block;
}

.page-container {
    height: 100%;
    background-image: url("../../assets/images/postalNewCustomer/awardBackground.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 15vh px2rem(40) 10vh;
    overflow: hidden;

    .navigation-content {
        height: 100%;
        position: relative;
        color: #ffffff;
        text-align: center;
        width: 100vw;
        display: flex;
        align-items: center;
        padding: 0 pxvw(40);

        .back {
            width: px2rem(34);
            height: px2rem(34);
        }

        .title {
            flex: 1;
            line-height: 100%;
            font-size: pxvw(32);
            display: table-cell;
            text-align: center;
            vertical-align: middle;
            font-weight: 600;
        }
    }

    .page-content {
        width: 100%;
        height: 100%;
        background-image: url(../../assets/images/postalNewCustomer/icon4.png),
            url(../../assets/images/postalNewCustomer/background.png);
        background-size: auto px2rem(80), 100% calc(100% - 2rem);
        background-repeat: no-repeat, no-repeat;
        background-position: top left px2rem(20), top px2rem(20) left 0;
        box-sizing: border-box;
        padding: px2rem(60) px2rem(20) px2rem(90);
        //overflow: hidden;

        .reward-list {
            height: 100%;
            overflow: auto;
            margin-top: 0;
            border-radius: px2rem(40);
        }

        .reward-item {
            height: px2rem(134);
            background-image: url("../../assets/images/postalNewCustomer/awardListback.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding-left: px2rem(110);
            display: flex;
            justify-content: space-between;
            vertical-align: center;

            .reward-info {
                flex: 1;
                overflow: hidden;
                padding-top: px2rem(20);

                .reward-name {
                    font-size: px2rem(32);
                    color: rgb(221, 98, 42);
                    font-weight: bolder;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .operation {
                padding: 0 px2rem(10);
                display: flex;
                flex-direction: column;
                justify-content: center;

                img {
                    width: px2rem(137);
                    height: auto;
                    display: block;
                    margin: 0 auto;
                }

                p {
                    text-align: center;
                    margin-top: px2rem(4);
                    color: #4fa8dc;
                }
            }
        }
    }
}
</style>
